/* eslint no-console: "off" */
import axios from 'axios'
import { API_ENDPOINT_BASE, ROOT } from '@/constans'
import { stringify } from 'qs'
import { ID, HOTELS, DEPARTURE, OCCUPATION, PASSENGERS, RATE, REVOCATIONS, PRICE, COMMISSIONABLE, STEP, LOADING, DATA } from '@/store/mutations'
import swal from 'sweetalert2'
import { set } from '@/utils'

export default {
  namespaced: true,
  state: {
    id: null,
    hotels: [],
    departure: {},
    occupation: null,
    passengers: [],
    rate: {},
    data: {},
    revocations: null,
    price: null,
    commissionable: null,
    step: null
  },
  mutations: {
    [ID]: set('id'),
    [HOTELS]: set('hotels'),
    [DEPARTURE]: set('departure'),
    [OCCUPATION]: set('occupation'),
    [PASSENGERS]: set('passengers'),
    [RATE]: set('rate'),
    [DATA]: set('data'),
    [REVOCATIONS]: set('revocations'),
    [PRICE]: set('price'),
    [COMMISSIONABLE]: set('commissionable'),
    [STEP]: set('step')
  },
  actions: {
    EDIT_PASSENGER ({ commit, state }, data) {
      commit(
        PASSENGERS,
        state.passengers.map(passenger => (passenger.id == data.id ? Object.assign({}, passenger, data) : passenger))
      )
    },
    SIT ({ commit, state }, { seat, id }) {
      commit(
        PASSENGERS,
        state.passengers.map(passenger =>
          passenger.id == id ? Object.assign({}, passenger, { seat_id: seat.id, seat_categ: seat.categ, seat_categ_str: seat.categ_str }) : passenger
        )
      )
    },
    DISTRIBUTE ({ commit, state }, { uid, id }) {
      commit(
        PASSENGERS,
        state.passengers.map(passenger => (passenger.id == id ? Object.assign({}, passenger, { rooms: passenger.rooms.concat([uid]) }) : passenger))
      )
    },
    RESET ({ commit }) {
      commit(ID, null)
      commit(HOTELS, [])
      commit(DEPARTURE, {})
      commit(OCCUPATION, null)
      commit(PASSENGERS, [])
      commit(RATE, {})
      commit(DATA, {})
      commit(REVOCATIONS, null)
      commit(PRICE, null)
      commit(COMMISSIONABLE, null)
      commit(STEP, null)
    },
    INIT ({ commit }, { reservation_id, revocations }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios
          .post(API_ENDPOINT_BASE + '/reservations/' + reservation_id + '/revocation/init', stringify({ revocations }))
          .then(({ data }) => {
            commit(ID, data.id)
            commit(HOTELS, data.hotels)
            commit(DEPARTURE, data.departure)
            commit(OCCUPATION, data.occupation)
            commit(PASSENGERS, data.passengers)
            commit(RATE, data.rate)
            commit(DATA, data.data)
            commit(REVOCATIONS, data.revocations)
            commit(PRICE, data.price)
            commit(COMMISSIONABLE, !!data.commissionable)
            commit(STEP, data.step)
            resolve()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    RATES ({ commit, state }, { reservation_id, hotels }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        return axios
          .post(API_ENDPOINT_BASE + '/reservations/' + reservation_id + '/revocation/rates', stringify({ hotels, id: state.id }))
          .then(({ data }) => {
            commit(ID, data.id)
            commit(HOTELS, data.hotels)
            commit(DEPARTURE, data.departure)
            commit(OCCUPATION, data.occupation)
            commit(PASSENGERS, data.passengers)
            commit(RATE, data.rate)
            commit(DATA, data.data)
            commit(REVOCATIONS, data.revocations)
            commit(PRICE, data.price)
            commit(COMMISSIONABLE, !!data.commissionable)
            commit(STEP, data.step)
            resolve()
          })
          .catch(error => {
            console.log([error])
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    BUDGETING ({ commit, state }, { reservation_id, passengers }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        return axios
          .post(API_ENDPOINT_BASE + '/reservations/' + reservation_id + '/revocation/budgeting', stringify({ passengers, id: state.id }))
          .then(({ data }) => {
            commit(ID, data.id)
            commit(HOTELS, data.hotels)
            commit(DEPARTURE, data.departure)
            commit(OCCUPATION, data.occupation)
            commit(PASSENGERS, data.passengers)
            commit(RATE, data.rate)
            commit(DATA, data.data)
            commit(REVOCATIONS, data.revocations)
            commit(PRICE, data.price)
            commit(COMMISSIONABLE, !!data.commissionable)
            commit(STEP, data.step)
            resolve()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    CONFIRM ({ commit, state }, { reservation_id, notes }) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        return axios
          .post(API_ENDPOINT_BASE + '/reservations/' + reservation_id + '/revocation/confirm', stringify({ notes, id: state.id }))
          .then(({ data }) => {
            commit(ID, data.id)
            commit(HOTELS, data.hotels)
            commit(DEPARTURE, data.departure)
            commit(OCCUPATION, data.occupation)
            commit(PASSENGERS, data.passengers)
            commit(RATE, data.rate)
            commit(DATA, data.data)
            commit(REVOCATIONS, data.revocations)
            commit(PRICE, data.price)
            commit(COMMISSIONABLE, !!data.commissionable)
            commit(STEP, data.step)
            resolve()
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    }
  }
}
